//@flow
import React, {useState} from 'react';
import {makeStyles, Typography, Tabs, Tab} from '@material-ui/core';
import {Link} from 'react-router-dom';

import CustomButton from '../../../../elements/CustomButton/CustomButton';
import BlogFilter from './BlogFilter';
import BlogList from './BlogList';
import BlogCategoryManager from './BlogFilter/BlogCategoryManager';
import {colors} from '../../../../assets/styles/colors';
import {useIsFeatureInTier} from '../../../../utils/component';
import {useTierRestrictionActions} from '../../../TierRestriction/utils';

const TAB_ENTRIES = 0;
const TAB_CATEGORIES = 1;

const useStyles = makeStyles(theme => ({
  container: {
    width: '100%',
    height: '100%',
    borderRadius: '.75rem',
    background: 'white',
    border: 'border: 1px solid #DDDDDD',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  tabsContainer: {
    borderBottom: `1px solid ${colors.grey300}`,
  },
  tabs: {
    minHeight: 'unset',
  },
  tab: {
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '1rem',
    minHeight: 48,
    color: colors.grey600,
    '&.Mui-selected': {
      color: colors.primary,
    },
  },
  tabIndicator: {
    backgroundColor: colors.primary,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '1rem',
    borderBottom: '1px solid #DDDDDD',
  },
  headerText: {
    fontSize: '1.35rem',
    fontWeight: 600,
    color: colors.grey800,
  },
  tabContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  categoryContent: {
    padding: '1rem',
    flex: 1,
    overflow: 'auto',
  },
}));

export default function BlogSummary() {
  const classes = useStyles();
  const hasBlogFeature = useIsFeatureInTier('STORE_BLOG');
  const {showTierRestrictionModal} = useTierRestrictionActions();

  const [activeTab, setActiveTab] = useState(TAB_ENTRIES);

  const handleTabChange = (event: any, newValue: number) => {
    setActiveTab(newValue);
  };

  const isEntriesTab = activeTab === TAB_ENTRIES;
  const isCategoriesTab = activeTab === TAB_CATEGORIES;

  return (
    <main className={classes.container}>
      <div className={classes.tabsContainer}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          classes={{
            root: classes.tabs,
            indicator: classes.tabIndicator,
          }}
        >
          <Tab label="Entradas" className={classes.tab} />
          <Tab label="Categorías" className={classes.tab} />
        </Tabs>
      </div>

      {isEntriesTab && (
        <div className={classes.tabContent}>
          <header className={classes.header}>
            <Typography className={classes.headerText}>Entradas</Typography>

            <CustomButton
              component={hasBlogFeature ? Link : undefined}
              variant="contained"
              to="/my-store/blog/new"
              onClick={e => {
                if (!hasBlogFeature) {
                  e.preventDefault();
                  showTierRestrictionModal();
                }
              }}
            >
              + Añadir entrada
            </CustomButton>
          </header>

          <BlogFilter />
          <BlogList />
        </div>
      )}

      {isCategoriesTab && (
        <div className={classes.categoryContent}>
          <BlogCategoryManager
            hasBlogFeature={hasBlogFeature}
            onTierRestriction={showTierRestrictionModal}
          />
        </div>
      )}
    </main>
  );
}
